import React, { useEffect, useState } from "react";
import {
  AddButton,
  CustomConfirmModal,
  PaginationDropdown,
  ThinDropdownWithSearch,
  ThinTextField,
} from "../common/GeneralComponent";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import {
  ChevronsRightIcon,
  Edit,
  Trash,
  Minus,
  Plus,
  Download,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { Pagination } from "@mui/material";
import { fetchData } from "../../utils/functions";
import "font-awesome/css/font-awesome.min.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";

import GeneralFooter from "../common/GeneralFooter";
import PermissionButton from "../common/PermissionButton";

const SchoolAssessment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user: loggedInUser } = useSelector((state) => state.auth);
  const permissions = loggedInUser?.user_permissions || [];

  const [schoolsData, setSchoolsData] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isModalVisible, setModalVisible] = useState(false);
  const [isApproveModalVisible, setApproveModalVisible] = useState(false);
  const [isRejectModalVisible, setRejectModalVisible] = useState(false);
  const [isRemarksModalVisible, setRemarksModalVisible] = useState(false);
  const [isViewRemarksModalVisible, setViewRemarksModalVisible] =
    useState(false);
  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState("");
  const [selectedUuid, setSelectedUuid] = useState(null);
  const [selectedApproveId, setSelectedApproveId] = useState(null);
  const [selectedRejectId, setSelectedRejectId] = useState(null);
  const [selectedSchoolForRemarks, setSelectedSchoolForRemarks] =
    useState(null);
  const [isFiltersVisible, setIsFiltersVisible] = useState(false);
  const [filterReset, setFilterReset] = useState(0);
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [appliedDistrict, setAppliedDistrict] = useState(null);
  const [tehsils, setTehsils] = useState([]);
  const [selectedTehsil, setSelectedTehsil] = useState(null);
  const [appliedTehsil, setAppliedTehsil] = useState(null);
  const [ucs, setUcs] = useState([]);
  const [selectedUc, setSelectedUc] = useState(null);
  const [appliedUc, setAppliedUc] = useState(null);
  const [dehs, setDehs] = useState([]);
  const [selectedDeh, setSelectedDeh] = useState(null);
  const [appliedDeh, setAppliedDeh] = useState(null);
  const [villages, setVillages] = useState([]);
  const [selectedVillages, setSelectedVillages] = useState(null);
  const [appliedVillages, setAppliedVillages] = useState(null);
  const [selectedDqaStatus, setSelectedDqaStatus] = useState(null);
  const [appliedDqaStatus, setAppliedDqaStatus] = useState(null);

  // Additional filters
  const [schoolLevels, setSchoolLevels] = useState([]);
  const [selectedSchoolLevel, setSelectedSchoolLevel] = useState(null);
  const [appliedSchoolLevel, setAppliedSchoolLevel] = useState(null);

  const [schoolTypes, setSchoolTypes] = useState([]);
  const [selectedSchoolType, setSelectedSchoolType] = useState(null);
  const [appliedSchoolType, setAppliedSchoolType] = useState(null);

  const [schoolCategories, setSchoolCategories] = useState([]);
  const [selectedSchoolCategory, setSelectedSchoolCategory] = useState(null);
  const [appliedSchoolCategory, setAppliedSchoolCategory] = useState(null);

  const [statusOptions, setStatusOptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [appliedStatus, setAppliedStatus] = useState(null);

  const [isExporting, setIsExporting] = useState(false);
  const [dateField, setDateField] = useState("");
  const [condition, setCondition] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [appliedDateField, setAppliedDateField] = useState(null);
  const [appliedCondition, setAppliedCondition] = useState(null);
  const [appliedDateValue, setAppliedDateValue] = useState(null);
  const [appliedStartDate, setAppliedStartDate] = useState(null);
  const [appliedEndDate, setAppliedEndDate] = useState(null);

  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
    total_records: 0,
    total_pages: 0,
  });
  const isMountedRef = React.useRef(true);

  const getLatestRemarks = (school) => {
    if (school.auditLogs && school.auditLogs.length > 0) {
      try {
        const latestAudit = school.auditLogs[0];
        const newValue = JSON.parse(latestAudit.newvalue);
        return (
          newValue.remarks ||
          school.remarks ||
          school.rejection_remarks ||
          "No remarks"
        );
      } catch (error) {
        console.warn("Failed to parse audit log:", error);
        return school.remarks || school.rejection_remarks || "No remarks";
      }
    }
    return school.remarks || school.rejection_remarks || "No remarks";
  };
  const getRemarksHistory = (school) => {
    if (!school.auditLogs || school.auditLogs.length === 0) {
      return [];
    }

    const history = [];
    school.auditLogs.forEach((log, index) => {
      try {
        const newValue = JSON.parse(log.newvalue);
        const oldValue = log.oldvalue ? JSON.parse(log.oldvalue) : null;

        history.push({
          action: log.action,
          date: log.createdAt,
          from: oldValue?.remarks || "None",
          to: newValue.remarks,
          userId: log.userId,
          UserName: log.user.name,
        });
      } catch (error) {
        console.warn("Failed to parse audit log:", error);
      }
    });

    return history;
  };
  const showRemarksDialog = (school) => {
    setSelectedSchoolForRemarks(school);
    setViewRemarksModalVisible(true);
  };
  const closeRemarksDialog = () => {
    setViewRemarksModalVisible(false);
    setSelectedSchoolForRemarks(null);
  };

  const validateRemarks = (remarksText) => {
    if (!remarksText.trim()) {
      return "Remarks are required";
    }
    if (remarksText.trim().length < 10) {
      return "Remarks must be at least 10 characters long";
    }
    if (remarksText.trim().length > 255) {
      return "Remarks cannot exceed 255 characters";
    }
    return "";
  };

  const handleRemarksChange = (value) => {
    setRemarks(value);
    if (remarksError) {
      const error = validateRemarks(value);
      setRemarksError(error);
    }
  };

  const hasFiltersApplied =
    appliedDistrict ||
    appliedTehsil ||
    appliedUc ||
    appliedDeh ||
    appliedVillages ||
    appliedSchoolLevel ||
    appliedSchoolType ||
    appliedSchoolCategory ||
    appliedStatus ||
    appliedDqaStatus ||
    appliedCondition;
  const hasDataToExport = schoolsData.length > 0;

  const dateFieldsOptions = [
    { value: "date_of_data_collection", label: "Date of Data Collection" },
    { value: "created_at", label: "Created Date" },
    { value: "verified_from_dqa_datetime", label: "DQA Approval Date" },
  ];

  const dqaStatusOptions = [
    { value: "0", label: "Pending" },
    { value: "1", label: "Approved" },
    { value: "2", label: "Rejected" },
  ];

  const conditions = [
    { value: "lt", label: "Less Than" },
    { value: "gt", label: "Greater Than" },
    { value: "equals", label: "Equal To" },
    { value: "between", label: "Between" },
  ];

  const toggleFilters = () => {
    setIsFiltersVisible((prev) => !prev);
  };

  const handleApplyFilters = () => {
    if (condition && !dateField) {
      toast.error("Please select a date field when using a condition");
      return;
    }

    if (condition === "between") {
      if (!startDate || !endDate) {
        toast.error(
          "Please provide both start and end dates for 'between' condition"
        );
        return;
      }
    }

    if (condition && condition !== "between" && !dateValue) {
      toast.error("Please provide a date value for the selected condition");
      return;
    }

    setAppliedDistrict(selectedDistrict);
    setAppliedTehsil(selectedTehsil);
    setAppliedUc(selectedUc);
    setAppliedDeh(selectedDeh);
    setAppliedVillages(selectedVillages);
    setAppliedSchoolLevel(selectedSchoolLevel);
    setAppliedSchoolType(selectedSchoolType);
    setAppliedSchoolCategory(selectedSchoolCategory);
    setAppliedStatus(selectedStatus);
    setAppliedDqaStatus(selectedDqaStatus);
    setAppliedDateField(dateField);
    setAppliedCondition(condition);

    if (condition === "between") {
      setAppliedStartDate(startDate);
      setAppliedEndDate(endDate);
      setAppliedDateValue(null);
    } else {
      setAppliedDateValue(dateValue);
      setAppliedStartDate(null);
      setAppliedEndDate(null);
    }

    setPagination((prev) => ({
      ...prev,
      current_page: 1,
    }));

    setSearch("");
    setDebouncedSearch("");
  };

  const handleClearFilters = () => {
    setSelectedDistrict(null);
    setSelectedTehsil(null);
    setSelectedUc(null);
    setSelectedDeh(null);
    setSelectedVillages(null);
    setSelectedSchoolLevel(null);
    setSelectedSchoolType(null);
    setSelectedSchoolCategory(null);
    setSelectedStatus(null);
    setSelectedDqaStatus(null);

    setAppliedDistrict(null);
    setAppliedTehsil(null);
    setAppliedUc(null);
    setAppliedDeh(null);
    setAppliedVillages(null);
    setAppliedSchoolLevel(null);
    setAppliedSchoolType(null);
    setAppliedSchoolCategory(null);
    setAppliedStatus(null);
    setAppliedDqaStatus(null);
    setAppliedDateField(null);
    setAppliedCondition(null);
    setAppliedDateValue(null);
    setAppliedStartDate(null);
    setAppliedEndDate(null);

    setDateField("");
    setCondition("");
    setDateValue("");
    setStartDate("");
    setEndDate("");

    setTehsils([]);
    setUcs([]);
    setDehs([]);
    setVillages([]);

    setSearch("");
    setDebouncedSearch("");

    setPagination((prev) => ({ ...prev, current_page: 1 }));

    setFilterReset((prev) => prev + 1);
  };

  const handleDistrictChange = (selected) => {
    const districtObj =
      typeof selected === "string" || typeof selected === "number"
        ? districts.find((d) => d.district_id === parseInt(selected))
          ? {
              value: parseInt(selected),
              label: districts.find((d) => d.district_id === parseInt(selected))
                .district_name,
            }
          : null
        : selected;

    setSelectedDistrict(districtObj);

    setSelectedTehsil(null);
    setSelectedUc(null);
    setSelectedDeh(null);
    setSelectedVillages(null);
    setTehsils([]);
    setUcs([]);
    setDehs([]);
    setVillages([]);
  };

  const handleTehsilChange = (selected) => {
    const tehsilObj =
      typeof selected === "string" || typeof selected === "number"
        ? tehsils.find((t) => t.tehsil_id === parseInt(selected))
          ? {
              value: parseInt(selected),
              label: tehsils.find((t) => t.tehsil_id === parseInt(selected))
                .tehsil_name,
            }
          : null
        : selected;

    setSelectedTehsil(tehsilObj);

    setSelectedUc(null);
    setSelectedDeh(null);
    setSelectedVillages(null);
    setUcs([]);
    setDehs([]);
    setVillages([]);
  };

  const handleUcChange = (selected) => {
    const ucObj =
      typeof selected === "string" || typeof selected === "number"
        ? ucs.find((u) => u.uc_id === parseInt(selected))
          ? {
              value: parseInt(selected),
              label: ucs.find((u) => u.uc_id === parseInt(selected)).uc_name,
            }
          : null
        : selected;

    setSelectedUc(ucObj);
    setSelectedDeh(null);
    setSelectedVillages(null);
    setDehs([]);
    setVillages([]);
  };

  const handleDehChange = (selected) => {
    const dehObj =
      typeof selected === "string" || typeof selected === "number"
        ? dehs.find((d) => d.deh_id === parseInt(selected))
          ? {
              value: parseInt(selected),
              label: dehs.find((d) => d.deh_id === parseInt(selected)).deh_name,
            }
          : null
        : selected;

    setSelectedDeh(dehObj);
    setSelectedVillages(null);
    setVillages([]);
  };

  const handleVillageChange = (selected) => {
    const villageObj =
      typeof selected === "string" || typeof selected === "number"
        ? villages.find((v) => v.village_id === parseInt(selected))
          ? {
              value: parseInt(selected),
              label: villages.find((v) => v.village_id === parseInt(selected))
                .village_name,
            }
          : null
        : selected;

    setSelectedVillages(villageObj);
  };

  // Handler for school level
  const handleSchoolLevelChange = (selected) => {
    setSelectedSchoolLevel(selected);
  };

  // Handler for school type
  const handleSchoolTypeChange = (selected) => {
    setSelectedSchoolType(selected);
  };

  // Handler for school category
  const handleSchoolCategoryChange = (selected) => {
    setSelectedSchoolCategory(selected);
  };

  // Handler for status
  const handleStatusChange = (selected) => {
    setSelectedStatus(selected);
  };

  // Handler for DQA status
  const handleDqaStatusChange = (value) => {
    setSelectedDqaStatus(value);
  };

  const handleFilterChange = (key, value) => {
    switch (key) {
      case "dateField":
        setDateField(value);
        if (value === "") {
          setCondition("");
          setDateValue("");
          setStartDate("");
          setEndDate("");
        }
        break;
      case "condition":
        setCondition(value);
        if (value !== "between") {
          setStartDate("");
          setEndDate("");
        } else {
          setDateValue("");
        }
        break;
      default:
        break;
    }
  };

  const fetchDistricts = async () => {
    try {
      const response = await fetchData(
        "districts",
        "GET",
        null,
        {},
        {},
        navigate,
        "/districts",
        dispatch
      );
      if (isMountedRef.current) {
        setDistricts(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching districts:", error);
    }
  };

  const fetchTehsils = async () => {
    if (!selectedDistrict) return;
    try {
      const response = await fetchData(
        "tehsils",
        "GET",
        null,
        {},
        { district_id: selectedDistrict?.value },
        navigate,
        "/tehsils",
        dispatch
      );
      if (isMountedRef.current) {
        setTehsils(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching tehsils:", error);
    }
  };

  const fetchUcs = async () => {
    if (!selectedTehsil) return;
    try {
      const response = await fetchData(
        "ucs",
        "GET",
        null,
        {},
        { tehsil_id: selectedTehsil?.value },
        navigate,
        "/ucs",
        dispatch
      );
      if (isMountedRef.current) {
        setUcs(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching UCs:", error);
    }
  };

  const fetchDehs = async () => {
    if (!selectedTehsil) return;
    try {
      const response = await fetchData(
        "dehs",
        "GET",
        null,
        {},
        { tehsil_id: selectedTehsil?.value },
        navigate,
        "/dehs",
        dispatch
      );
      if (isMountedRef.current) {
        setDehs(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching Dehs:", error);
    }
  };

  const fetchVillages = async () => {
    if (!selectedDeh) return;
    try {
      const response = await fetchData(
        "villages",
        "GET",
        null,
        {},
        { deh_id: selectedDeh?.value },
        navigate,
        "/villages",
        dispatch
      );
      if (isMountedRef.current) {
        setVillages(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching Villages:", error);
    }
  };

  // Fetch filter options
  const fetchFilterOptions = async () => {
    try {
      // Fetch unique values for filters from existing data or API
      const response = await fetchData(
        "school-fetch",
        "GET",
        null,
        {},
        { page: 1, limit: 1000 },
        navigate,
        "/school-fetch",
        dispatch
      );

      if (response?.data?.school_profile) {
        const schools = response.data.school_profile;

        // Extract unique school levels
        const levels = [
          ...new Set(schools.map((s) => s.school_level).filter(Boolean)),
        ];
        setSchoolLevels(
          levels.map((level) => ({ value: level, label: level }))
        );

        // Extract unique school types
        const types = [
          ...new Set(schools.map((s) => s.school_type).filter(Boolean)),
        ];
        setSchoolTypes(types.map((type) => ({ value: type, label: type })));

        // Extract unique school categories
        const categories = [
          ...new Set(schools.map((s) => s.school_category).filter(Boolean)),
        ];
        setSchoolCategories(
          categories.map((category) => ({ value: category, label: category }))
        );

        // Status options
        setStatusOptions([
          { value: "1", label: "Active" },
          { value: "0", label: "Inactive" },
        ]);
      }
    } catch (error) {
      console.error("Error fetching filter options:", error);
    }
  };

  const fetchSchools = async () => {
    try {
      const params = {
        page: pagination.current_page,
        limit: pagination.per_page,
      };
      if (debouncedSearch?.trim()) {
        params.search = debouncedSearch.trim();
      }

      if (appliedDistrict?.value != null) {
        params.district_id = String(appliedDistrict.value);
      }

      if (appliedTehsil?.value != null) {
        params.tehsil_id = String(appliedTehsil.value);
      }

      if (appliedUc?.value != null) {
        params.uc_id = String(appliedUc.value);
      }

      if (appliedDeh?.value != null) {
        params.deh_id = String(appliedDeh.value);
      }

      if (appliedVillages?.value != null) {
        params.village_id = String(appliedVillages.value);
      }

      // Add new filter params
      if (appliedSchoolLevel?.value) {
        params.school_level = appliedSchoolLevel.value;
      }

      if (appliedSchoolType?.value) {
        params.school_type = appliedSchoolType.value;
      }

      if (appliedSchoolCategory?.value) {
        params.school_category = appliedSchoolCategory.value;
      }

      if (appliedStatus?.value) {
        params.status = appliedStatus.value;
      }

      // IMPORTANT: This should be 'verified_from_dqa' (not 'dqa_status')
      if (appliedDqaStatus) {
        params.verified_from_dqa = appliedDqaStatus;
      }

      if (appliedDateField) {
        params.date_field = appliedDateField;
      }

      if (appliedCondition) {
        params.condition = appliedCondition;
      }

      if (appliedDateValue) {
        params.date_value = appliedDateValue;
      }

      if (appliedStartDate) {
        params.start_date = appliedStartDate;
      }

      if (appliedEndDate) {
        params.end_date = appliedEndDate;
      }

      const response = await fetchData(
        "school-fetch",
        "GET",
        null,
        {},
        params,
        navigate,
        "/school-fetch",
        dispatch
      );

      if (!response?.data?.school_profile) {
        console.warn("No school_profile data in response");
        setSchoolsData([]);
        setPagination({
          current_page: 1,
          per_page: 10,
          total_pages: 0,
          total_records: 0,
        });
        return;
      }

      const sortedData = (response.data.school_profile || []).sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      setSchoolsData(sortedData);
      const pag = response.data.pagination;
      setPagination({
        current_page: pag?.currentPage || 1,
        per_page: pag?.itemsPerPage || 10,
        total_pages: pag?.totalPages || 1,
        total_records: pag?.totalItems || 0,
      });
    } catch (error) {
      console.error(" Error fetching schools:", error);
      setSchoolsData([]);
      toast.error("Failed to fetch schools. Please try again.");
    }
  };

  const fetchAllSchoolsForExport = async () => {
    try {
      const params = {
        page: 1,
        limit: 10000,
      };
      if (debouncedSearch) params.search = debouncedSearch;
      if (appliedDistrict?.value) params.district_id = appliedDistrict.value;
      if (appliedTehsil?.value) params.tehsil_id = appliedTehsil.value;
      if (appliedUc?.value) params.uc_id = appliedUc.value;
      if (appliedDeh?.value) params.deh_id = appliedDeh.value;
      if (appliedVillages?.value) params.village_id = appliedVillages.value;
      if (appliedSchoolLevel?.value)
        params.school_level = appliedSchoolLevel.value;
      if (appliedSchoolType?.value)
        params.school_type = appliedSchoolType.value;
      if (appliedSchoolCategory?.value)
        params.school_category = appliedSchoolCategory.value;
      if (appliedStatus?.value) params.status = appliedStatus.value;
      if (appliedDqaStatus) params.verified_from_dqa = appliedDqaStatus;
      if (appliedDateField) params.date_field = appliedDateField;
      if (appliedCondition) params.condition = appliedCondition;
      if (appliedDateValue) params.date_value = appliedDateValue;
      if (appliedStartDate) params.start_date = appliedStartDate;
      if (appliedEndDate) params.end_date = appliedEndDate;

      const response = await fetchData(
        "school-fetch",
        "GET",
        null,
        {},
        params,
        navigate,
        "/school-assessment",
        dispatch
      );

      const schools = response?.data?.school_profile || [];
      return schools;
    } catch (error) {
      return [];
    }
  };

  const handleExport = async () => {
    if (!hasDataToExport) {
      toast.warning("No data available to export.");
      return;
    }

    setIsExporting(true);

    try {
      const allSchools = await fetchAllSchoolsForExport();

      if (allSchools.length === 0) {
        toast.warning("No schools found with current filters.");
        setIsExporting(false);
        return;
      }

      const detailedSchools = await Promise.all(
        allSchools.map(async (school) => {
          try {
            const detailResponse = await fetchData(
              `school-fetchById/${school.school_profile_id}`,
              "GET",
              null,
              {},
              {},
              navigate,
              "/school-assessment",
              dispatch
            );

            if (!detailResponse?.data) {
              console.warn(
                `No data returned for school ID: ${school.school_profile_id}`
              );
              return null;
            }

            return detailResponse.data;
          } catch (error) {
            console.error(
              `Error fetching details for school ${school.school_profile_id}:`,
              error
            );
            return null;
          }
        })
      );

      const validSchools = detailedSchools.filter((school) => school !== null);

      if (validSchools.length === 0) {
        toast.error("Failed to fetch detailed school data. Please try again.");
        setIsExporting(false);
        return;
      }

      const workbook = XLSX.utils.book_new();
      const comprehensiveData = validSchools.map((school) => {
        const profile = school.SchoolProfile || {};
        const infrastructure = school.schoolInfrastructure || {};
        const facilities = school.schoolFacility || {};
        const administrative = school.SchoolAdministrative || {};
        const notes = school.SchoolAdditionalNotes || {};

        return {
          District: profile.district_name || "N/A",
          Tehsil: profile.tehsil_name || "N/A",
          UC: profile.uc_name || "N/A",
          Deh: profile.deh_name || "N/A",
          Village: profile.village_name || "N/A",

          "School ID": profile.school_profile_id || "N/A",
          "School Name": profile.school_name || "N/A",
          "SEMIS Code": profile.semis_code || "N/A",
          "School Level": profile.school_level || "N/A",
          "School Type": profile.school_type || "N/A",
          "School Category": profile.school_category || "N/A",
          Medium: profile.medium || "N/A",
          "Number of Shifts": profile.number_of_shifts || "N/A",
          "Head Teacher Name": profile.head_teacher_name || "N/A",
          "Head Teacher Contact": profile.head_teacher_contact || "N/A",
          "Boys Enrollment": profile.enrollment_of_boys || 0,
          "Girls Enrollment": profile.enrollment_of_girls || 0,
          "Total Enrollment": profile.enrollment_total || 0,
          Mission: profile.mission || "N/A",
          "Status of School": profile.status_of_school || "N/A",
          Address: profile.address || school.address || "N/A",
          Latitude: profile.latitude || "N/A",
          Longitude: profile.longitude || "N/A",
          "Date of Data Collection": profile.date_of_data_collection || "N/A",
          "DQA Status":
            profile.verified_from_dqa === 1
              ? "Approved"
              : profile.verified_from_dqa === 2
              ? "Rejected"
              : "Pending",
          "Rejection Remarks": profile.rejection_remarks || "N/A",
          "Active Status": profile.status ? "Active" : "Inactive",

          "Building Ownership": infrastructure.building_ownership || "N/A",
          "Structure Type": infrastructure.structure_type || "N/A",
          "Building Condition": infrastructure.condition || "N/A",
          "Total Rooms": infrastructure.total_rooms || 0,
          "Total Classrooms": infrastructure.total_classrooms || 0,
          "Functional Classrooms": infrastructure.classrooms_functional || 0,
          "Non-Functional Classrooms":
            infrastructure.classrooms_non_functional || 0,
          "Classes in Open": infrastructure.classes_in_open ? "Yes" : "No",
          "Boundary Wall": infrastructure.boundary_wall ? "Yes" : "No",
          "Electricity Available": infrastructure.electricity_available
            ? "Yes"
            : "No",
          "Water Source": infrastructure.water_source || "N/A",
          "Water Storage Type": infrastructure.water_storage_type || "N/A",
          "Handwashing Facility": infrastructure.handwashing_facility
            ? "Yes"
            : "No",
          "Total Toilets": infrastructure.total_toilets || 0,
          "Functional Toilets": infrastructure.functional_toilets || 0,
          Drainage: infrastructure.drainage || "N/A",
          "Ventilation & Lighting":
            infrastructure.ventilation_lighting || "N/A",
          "Furniture Ratio": infrastructure.furniture_ratio || "N/A",
          "First Aid Box": infrastructure.first_aid_box ? "Yes" : "No",

          "Library Room": facilities.library_room ? "Yes" : "No",
          "Library Books Count": facilities.library_books_count || 0,
          "Computer Lab": facilities.computer_lab ? "Yes" : "No",
          "Computers Count": facilities.computers_count || 0,
          "Science Lab": facilities.science_lab ? "Yes" : "No",
          "Science Lab Equipped": facilities.science_lab_equipped
            ? "Yes"
            : "No",
          "Playground Location": facilities.playground_location || "N/A",
          "Hall/Assembly Area": facilities.hall_assembly_area ? "Yes" : "No",
          "Playground Surface": facilities.playground_surface || "N/A",
          "Learning Materials": facilities.learning_materials || "N/A",
          "Extracurricular Activities": facilities.extracurricular_activities
            ? "Yes"
            : "No",
          "Extracurricular Types": facilities.extracurricular_types || "N/A",

          "Male Teachers": administrative.male_school_teachers || 0,
          "Female Teachers": administrative.female_school_teachers || 0,
          "Teaching Staff": administrative.teaching_staff || 0,
          "Non-Teaching Staff": administrative.non_teaching_staff || 0,
          "SMC/PTA Functional": administrative.smc_pta_functional
            ? "Yes"
            : "No",
          "SMC/PTA Members": administrative.smc_pta_members || 0,
          "Grant Received": administrative.grant_received ? "Yes" : "No",
          "Grant Source": administrative.grant_source || "N/A",

          "Tree Plantation": notes.tree_plantation ? "Yes" : "No",
          "Student Issues": notes.student_issues || "N/A",
          Remarks: notes.remarks || "N/A",

          "Created By": profile.createdBy_name || "N/A",
          "Created At": profile.created_at || "N/A",
        };
      });

      const worksheet = XLSX.utils.json_to_sheet(comprehensiveData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Complete School Data");
      let filename = "school_complete_export";

      if (appliedDistrict) {
        const districtName =
          districts.find((d) => d.district_id === appliedDistrict.value)
            ?.district_name || appliedDistrict.label;
        filename += `_${districtName.replace(/\s+/g, "_")}`;
      }
      if (appliedTehsil) {
        const tehsilName =
          tehsils.find((t) => t.tehsil_id === appliedTehsil.value)
            ?.tehsil_name || appliedTehsil.label;
        filename += `_${tehsilName.replace(/\s+/g, "_")}`;
      }
      if (appliedUc) {
        const ucName =
          ucs.find((u) => u.uc_id === appliedUc.value)?.uc_name ||
          appliedUc.label;
        filename += `_${ucName.replace(/\s+/g, "_")}`;
      }
      if (appliedVillages) {
        const villageName =
          villages.find((v) => v.village_id === appliedVillages.value)
            ?.village_name || appliedVillages.label;
        filename += `_${villageName.replace(/\s+/g, "_")}`;
      }

      const currentDate = new Date().toISOString().split("T")[0];
      filename += `_${currentDate}.xlsx`;

      XLSX.writeFile(workbook, filename);

      toast.success(
        `Export completed! ${validSchools.length} schools exported successfully.`
      );
    } catch (error) {
      console.error("Error during export:", error);
      toast.error("Failed to export data. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (search === debouncedSearch) return;
      setDebouncedSearch(search);
      setPagination((prev) => ({ ...prev, current_page: 1 }));
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchSchools();
    }, 100);

    return () => clearTimeout(timer);
  }, [
    appliedDistrict,
    appliedTehsil,
    appliedUc,
    appliedDeh,
    appliedVillages,
    appliedSchoolLevel,
    appliedSchoolType,
    appliedSchoolCategory,
    appliedStatus,
    appliedDqaStatus,
    appliedDateField,
    appliedCondition,
    appliedDateValue,
    appliedStartDate,
    appliedEndDate,
    debouncedSearch,
    pagination.current_page,
    pagination.per_page,
  ]);

  useEffect(() => {
    fetchDistricts();
    fetchFilterOptions();
  }, []);

  useEffect(() => {
    fetchTehsils();
  }, [selectedDistrict]);

  useEffect(() => {
    fetchUcs();
  }, [selectedTehsil]);

  useEffect(() => {
    fetchDehs();
  }, [selectedTehsil]);

  useEffect(() => {
    fetchVillages();
  }, [selectedDeh]);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handlePageSizeChange = (size) => {
    setPagination((prev) => ({ ...prev, per_page: size, current_page: 1 }));
  };

  const handlePageChange = (event, value) => {
    setPagination((prev) => ({ ...prev, current_page: value }));
  };

  const handleDelete = async () => {
    setModalVisible(false);
    setSchoolsData((prev) =>
      prev.filter((school) => school.school_profile_id !== selectedUuid)
    );

    try {
      const response = await fetchData(
        `school-delete/${selectedUuid}`,
        "DELETE",
        {},
        {},
        {},
        navigate,
        "/school-assessment",
        dispatch
      );

      if (!response?.success) {
        throw new Error(response?.message || "Failed to delete the school.");
      }

      toast.success("School deleted successfully.");
    } catch (error) {
      console.error("Error deleting school:", error);
      toast.error(
        error?.message || "An error occurred while deleting the school."
      );
      fetchSchools();
    }
  };
  const handleApprove = async () => {
    setApproveModalVisible(false);
    try {
      const response = await fetchData(
        `school-approve/${selectedApproveId}`,
        "PUT",
        {},
        {},
        {},
        navigate,
        "/school-assessment",
        dispatch
      );

      if (!response?.success) {
        throw new Error(response?.message || "Failed to approve school.");
      }

      toast.success("School approved successfully.");

      const currentDateTime = new Date().toISOString();
      setSchoolsData((prev) =>
        prev.map((school) =>
          school.school_profile_id === selectedApproveId
            ? {
                ...school,
                verified_from_dqa: 1,
                verified_from_dqa_datetime: currentDateTime,
              }
            : school
        )
      );
    } catch (error) {
      console.error("Error approving school:", error);
      toast.error(
        error?.message || "An error occurred while approving the school."
      );
    }
  };
  const handleReject = async () => {
    setRejectModalVisible(false);
    setRemarksModalVisible(true);
  };
  const handleSubmitRemarks = async () => {
    const validationError = validateRemarks(remarks);
    if (validationError) {
      setRemarksError(validationError);
      return;
    }

    try {
      const response = await fetchData(
        `school-reject/${selectedRejectId}`,
        "PUT",
        { remarks: remarks.trim(), verified_from_dqa_status: 2 },
        {},
        {},
        navigate,
        "/school-assessment",
        dispatch
      );

      if (!response?.success) {
        throw new Error(response?.message || "Failed to reject school.");
      }

      toast.success("School rejected successfully.");

      const currentDateTime = new Date().toISOString();
      setSchoolsData((prev) =>
        prev.map((school) =>
          school.school_profile_id === selectedRejectId
            ? {
                ...school,
                verified_from_dqa: 2,
                verified_from_dqa_datetime: currentDateTime,
                rejection_remarks: remarks.trim(),
              }
            : school
        )
      );
      // Auto reload the listing
      await fetchSchools();
      setRemarksModalVisible(false);
      setRemarks("");
      setRemarksError("");
    } catch (error) {
      console.error("Error rejecting school:", error);
      toast.error(
        error?.message || "An error occurred while rejecting the school."
      );
    }
  };
  const handleCancelRemarks = () => {
    setRemarksModalVisible(false);
    setRemarks("");
    setRemarksError("");
  };

  const showDeleteModal = (id) => {
    setSelectedUuid(id);
    setModalVisible(true);
  };

  const showApproveModal = (id) => {
    setSelectedApproveId(id);
    setApproveModalVisible(true);
  };

  const showRejectModal = (id) => {
    setSelectedRejectId(id);
    setRejectModalVisible(true);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const formatApprovalDateTime = (dateTimeString) => {
    if (!dateTimeString) return null;

    const date = new Date(dateTimeString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDateTimeForDisplay = (dateTimeString) => {
    if (!dateTimeString) return "N/A";

    const date = new Date(dateTimeString);
    if (isNaN(date)) return "N/A";

    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const toggleStatus = async (schoolId, newStatus) => {
    try {
      const response = await fetchData(
        `school-status/${schoolId}`,
        "PUT",
        { status: newStatus },
        {},
        {},
        navigate,
        "/school-assessment",
        dispatch
      );

      if (!response?.success) {
        throw new Error(response?.message || "Failed to update status.");
      }
      setSchoolsData((prev) =>
        prev.map((school) =>
          school.school_profile_id === schoolId
            ? { ...school, status: newStatus }
            : school
        )
      );

      toast.success("School status updated successfully.");
    } catch (error) {
      console.error("Status update error:", error);
      toast.error(error?.message || "An error occurred while updating status.");
    }
  };

  const columns = [
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          School Name
        </span>
      ),
      selector: (row) => row.school_name || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          SEMIS Code
        </span>
      ),
      selector: (row) => row.semis_code || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          School Category
        </span>
      ),
      selector: (row) => row.school_category || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          School Type
        </span>
      ),
      selector: (row) => row.school_type || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          DQA Approval
        </span>
      ),
      cell: (row) => {
        const isApproved = row.verified_from_dqa === 1;
        const isRejected = row.verified_from_dqa === 2;
        const date = formatApprovalDateTime(row.verified_from_dqa_datetime);

        return (
          <div className="text-center">
            {isApproved ? (
              <>
                <span className="py-1 px-2 text-[0.75rem] rounded-full font-semibold bg-blue-100 text-blue-800">
                  Approved
                </span>
                {date && (
                  <div className="text-[0.65rem] text-gray-600 mt-2">
                    {date}
                  </div>
                )}
              </>
            ) : isRejected ? (
              <>
                <span className="py-1 px-2 text-[0.75rem] rounded-full font-semibold bg-red-100 text-red-800">
                  Rejected
                </span>
                {date && (
                  <div className="text-[0.65rem] text-gray-600 mt-2">
                    {date}
                  </div>
                )}
              </>
            ) : (
              <span className="py-1 px-2 text-[0.75rem] rounded-full font-semibold bg-yellow-100 text-yellow-800 ml-6">
                Pending
              </span>
            )}
          </div>
        );
      },
    },
  ];
  if (
    permissions.includes("school-assessment-update") ||
    permissions.includes("school-assessment-delete") ||
    permissions.includes("school-assessment-approve") ||
    permissions.includes("school-assessment-reject")
  ) {
    columns.push({
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">Action</span>
      ),
      cell: (row) => {
        const isApproved =
          row.verified_from_dqa === 1 || row.verified_from_dqa === "1";
        const isRejected =
          row.verified_from_dqa === 2 || row.verified_from_dqa === "2";
        const hasRemarks = getLatestRemarks(row) !== "No remarks";

        return (
          <div className="flex gap-2">
            {/* View Remarks Button */}
            {hasRemarks && (
              <button
                onClick={() => showRemarksDialog(row)}
                title="View Remarks"
                className="text-blue-600 hover:text-blue-800 hover:scale-110 transition-transform"
              >
                <i className="fa-solid fa-comment fa-lg"></i>
              </button>
            )}

            <PermissionButton
              hasPermission={permissions.includes("school-assessment-update")}
              to={`/school-assessment/edit/${row.school_profile_id}`}
              faIcon={
                isApproved || isRejected
                  ? "fa-solid fa-eye fa-lg"
                  : "fa-solid fa-pen-to-square fa-lg"
              }
              onlyIcon={true}
              enabledClass=""
              disabledClass="opacity-50 cursor-not-allowed"
            />
            {permissions.includes("school-assessment-approve") &&
              !isApproved &&
              !isRejected && (
                <button
                  onClick={() => showApproveModal(row.school_profile_id)}
                  title="Approve"
                  className="hover:scale-110 transition-transform"
                >
                  <i className="fa-solid fa-check-circle fa-lg text-green-600 hover:text-green-800"></i>
                </button>
              )}
            {permissions.includes("school-assessment-reject") &&
              !isApproved &&
              !isRejected && (
                <button
                  onClick={() => showRejectModal(row.school_profile_id)}
                  title="Reject"
                  className="hover:scale-110 transition-transform"
                >
                  <i className="fa-solid fa-times-circle fa-lg text-red-600 hover:text-red-800"></i>
                </button>
              )}
            {permissions.includes("school-assessment-delete") &&
              !isApproved && (
                <PermissionButton
                  hasPermission={permissions.includes(
                    "school-assessment-delete"
                  )}
                  faIcon="fa fa-trash fa-lg text-primaryDark"
                  onlyIcon
                  onClick={() => showDeleteModal(row.school_profile_id)}
                  className="p-1 rounded-full bg-gray-200 text-[#137e81] hover:text-white"
                  enabledClass=""
                  disabledClass="opacity-50 cursor-not-allowed bg-gray-300"
                />
              )}
          </div>
        );
      },
    });
  }

  const customStyles = {
    headCells: {
      style: {
        border: "1px solid #f3f3f3",
        backgroundColor: "#fff",
        color: "black",
        fontWeight: "bold",
        fontSize: "1.075rem",
        textAlign: "center",
      },
    },
    cells: {
      style: {
        border: "1px solid #f3f3f3",
        textAlign: "center",
      },
    },
  };

  return (
    <div>
      <div className="my-4 flex justify-between items-center">
        <h1 className="text-[1.475rem] text-[#212529] font-[Bold]">
          School Assessment
        </h1>

        {hasDataToExport && (
          <button
            onClick={handleExport}
            disabled={isExporting}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all ${
              isExporting
                ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                : "bg-[#137e81] text-white hover:bg-[#0f6c6f] hover:scale-105"
            }`}
            title="Export filtered data to Excel"
          >
            <Download size={18} />
            {isExporting ? "Exporting..." : "Export Excel"}
          </button>
        )}
      </div>

      <Accordion>
        <AccordionSummary
          expandIcon={
            isFiltersVisible ? (
              <Minus color="#ffff" size={14} />
            ) : (
              <Plus size={14} color="#ffff" />
            )
          }
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{
            backgroundColor: "#137e81",
            color: "#fff !important",
            "& .MuiAccordionSummary-content": {
              color: "#fff !important",
            },
          }}
          onClick={toggleFilters}
        >
          Filters
        </AccordionSummary>

        <AccordionDetails>
          <div className="space-y-4">
            {/* ===== Row 1: Location Filters (4 dropdowns) ===== */}
            <div className="flex gap-5 w-full">
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`district-${filterReset}`}
                  label="District"
                  id="district-dropdown"
                  options={districts?.map((d) => ({
                    value: d?.district_id,
                    label: d?.district_name,
                  }))}
                  value={selectedDistrict?.value || selectedDistrict}
                  onChange={handleDistrictChange}
                />
              </div>
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`tehsil-${filterReset}`}
                  label="Tehsil"
                  id="tehsil-dropdown"
                  options={tehsils?.map((t) => ({
                    value: t?.tehsil_id,
                    label: t?.tehsil_name,
                  }))}
                  value={selectedTehsil?.value || selectedTehsil}
                  onChange={handleTehsilChange}
                />
              </div>
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`deh-${filterReset}`}
                  label="Deh"
                  id="deh-dropdown"
                  options={dehs?.map((d) => ({
                    value: d?.deh_id,
                    label: d?.deh_name,
                  }))}
                  value={selectedDeh?.value || selectedDeh}
                  onChange={handleDehChange}
                />
              </div>
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`village-${filterReset}`}
                  label="Village"
                  id="village-dropdown"
                  options={villages?.map((v) => ({
                    value: v?.village_id,
                    label: v?.village_name,
                  }))}
                  value={selectedVillages?.value || selectedVillages}
                  onChange={handleVillageChange}
                />
              </div>
            </div>

            {/* ===== Row 2: School Filters (4 dropdowns) ===== */}
            <div className="flex gap-5 w-full">
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`school-level-${filterReset}`}
                  label="School Level"
                  id="school-level-dropdown"
                  options={schoolLevels}
                  value={selectedSchoolLevel?.value || selectedSchoolLevel}
                  onChange={handleSchoolLevelChange}
                />
              </div>
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`school-type-${filterReset}`}
                  label="School Type"
                  id="school-type-dropdown"
                  options={schoolTypes}
                  value={selectedSchoolType?.value || selectedSchoolType}
                  onChange={handleSchoolTypeChange}
                />
              </div>
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`school-category-${filterReset}`}
                  label="School Category"
                  id="school-category-dropdown"
                  options={schoolCategories}
                  value={
                    selectedSchoolCategory?.value || selectedSchoolCategory
                  }
                  onChange={handleSchoolCategoryChange}
                />
              </div>
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  key={`status-${filterReset}`}
                  label="Status"
                  id="status-dropdown"
                  options={statusOptions}
                  value={selectedStatus?.value || selectedStatus}
                  onChange={handleStatusChange}
                />
              </div>
            </div>

            {/* ===== Row 3: DQA + Date Filters ===== */}
            <div className="flex gap-5 w-full items-end">
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  label="DQA Status"
                  id="dqa-status-dropdown"
                  options={dqaStatusOptions}
                  value={selectedDqaStatus}
                  onChange={handleDqaStatusChange}
                />
              </div>
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  label="Date Field"
                  id="date-field-dropdown"
                  options={dateFieldsOptions}
                  value={dateField}
                  onChange={(value) => handleFilterChange("dateField", value)}
                />
              </div>
              <div className="flex-1">
                <ThinDropdownWithSearch required={false}
                  label="Condition"
                  id="condition-dropdown"
                  options={conditions}
                  value={condition}
                  onChange={(value) => handleFilterChange("condition", value)}
                  disabled={!dateField}
                />
              </div>
              <div className="flex-1">
                {condition === "between" ? (
                  <div className="flex gap-2">
                    <ThinTextField isRequired={false}
                      label="Start Date"
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                    <ThinTextField isRequired={false}
                      label="End Date"
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                ) : (
                  <ThinTextField isRequired={false}
                    label="Date Value"
                    type="date"
                    value={dateValue}
                    onChange={(e) => setDateValue(e.target.value)}
                    disabled={!condition || condition === "between"}
                  />
                )}
              </div>
            </div>
          </div>

          {/* ===== Buttons ===== */}
          <div className="flex gap-2 mt-4 justify-end">
            <button
              onClick={handleClearFilters}
              className="px-4 py-2 bg-[#be9609] text-white rounded-lg hover:bg-[#a68108] transition-colors"
            >
              Clear
            </button>
            <button
              onClick={handleApplyFilters}
              className="px-4 py-2 bg-[#137e81] text-white rounded-lg hover:bg-[#0f6c6f] transition-colors"
            >
              Apply
            </button>
          </div>
        </AccordionDetails>
      </Accordion>

      <div className="rounded-lg my-[15px] shadow w-full bg-white">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
          <h1 className="text-[0.875rem] tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Manage School Assessment
          </h1>

          {(hasFiltersApplied || debouncedSearch) && (
            <div className="text-sm text-gray-600">
              {pagination.total_records} records found
              {hasDataToExport && (
                <span className="ml-2 text-green-600 font-medium">
                  • Export available
                </span>
              )}
            </div>
          )}
        </div>
        <div className="p-[1.25rem] w-full">
          <div className="flex lg:flex-row flex-col lg:justify-between justify-start gap-2 lg:items-center items-start mb-[6px] w-full">
            <PaginationDropdown
              value={pagination.per_page}
              onChange={handlePageSizeChange}
              options={[
                { value: 10, label: "10" },
                { value: 20, label: "20" },
                { value: 30, label: "30" },
              ]}
            />

            <input
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              placeholder="Search..."
              type="search"
              className="font-[Light] text-[14px] flex items-center bg-[#f1f4f8] border-[#ebeef2] border-[1px] rounded-md px-3 py-1 outline-none"
            />
          </div>
          <DataTable
            columns={columns}
            data={schoolsData}
            persistTableHead
            customStyles={customStyles}
            highlightOnHover
            progressPending={false}
          />
          <GeneralFooter
            pagination={pagination}
            handlePageChange={handlePageChange}
            handlePageSizeChange={handlePageSizeChange}
            dataLength={schoolsData.length}
          />
        </div>
      </div>

      <CustomConfirmModal
        isVisible={isModalVisible}
        onConfirm={handleDelete}
        onCancel={() => setModalVisible(false)}
        message="Are you sure you want to delete this School?"
      />
      <CustomConfirmModal
        isVisible={isApproveModalVisible}
        onConfirm={handleApprove}
        onCancel={() => setApproveModalVisible(false)}
        message="Are you sure you want to approve this School from DQA?"
      />
      <CustomConfirmModal
        isVisible={isRejectModalVisible}
        onConfirm={handleReject}
        onCancel={() => setRejectModalVisible(false)}
        message="Are you sure you want to reject this School from DQA?"
      />
      <Dialog
        open={isViewRemarksModalVisible}
        onClose={closeRemarksDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "8px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            maxWidth: "600px",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#137e81",
            color: "white",
            padding: "16px 24px",
            fontSize: "1.25rem",
            fontWeight: "bold",
          }}
        >
          Remarks History
          {selectedSchoolForRemarks && (
            <Typography
              variant="subtitle1"
              sx={{ color: "white", fontSize: "0.9rem", mt: 1 }}
            >
              School: {selectedSchoolForRemarks.school_name} -{" "}
              {selectedSchoolForRemarks.semis_code}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent sx={{ padding: "24px", maxHeight: "60vh" }}>
          {selectedSchoolForRemarks && (
            <Box>
              <Box
                sx={{
                  mb: 3,
                  p: 2,
                  backgroundColor: "#f8f9fa",
                  borderRadius: "4px",
                }}
              ></Box>

              <Typography
                variant="h6"
                sx={{ mb: 2, color: "#137e81" }}
              ></Typography>

              {getRemarksHistory(selectedSchoolForRemarks).length > 0 ? (
                <Box sx={{ maxHeight: "300px", overflowY: "auto" }}>
                  {getRemarksHistory(selectedSchoolForRemarks).map(
                    (history, index) => (
                      <Box
                        key={index}
                        sx={{
                          mb: 2,
                          p: 2,
                          border: "1px solid #e0e0e0",
                          borderRadius: "4px",
                          backgroundColor: index === 0 ? "#f0f8ff" : "white",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            mb: 1,
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: "bold", color: "#333" }}
                          ></Typography>
                          <Typography variant="caption" sx={{ color: "#666" }}>
                            {formatDateTimeForDisplay(history.date)}
                          </Typography>
                        </Box>

                        <Box sx={{ mt: 1 }}>
                          <Typography
                            variant="body2"
                            sx={{ mb: 0.5 }}
                          ></Typography>
                          <Typography variant="body2">
                            <strong>Remarks:</strong>{" "}
                            <span
                              style={{ color: "#2e7d32", fontWeight: "bold" }}
                            >
                              {history.to}
                            </span>
                          </Typography>
                        </Box>

                        <Typography
                          variant="caption"
                          sx={{ color: "#666", mt: 1, display: "block" }}
                        >
                          User ID: {history.UserName}
                        </Typography>
                      </Box>
                    )
                  )}
                </Box>
              ) : (
                <Typography
                  variant="body1"
                  sx={{ textAlign: "center", color: "#666", py: 3 }}
                >
                  No remarks history available
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button
            onClick={closeRemarksDialog}
            color="primary"
            variant="contained"
            sx={{
              backgroundColor: "#137e81",
              "&:hover": {
                backgroundColor: "#0f6c6f",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* Rejection Remarks Modal */}
      <Dialog
        open={isRemarksModalVisible}
        onClose={handleCancelRemarks}
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: "8px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#137e81",
            color: "white",
            padding: "16px 24px",
            fontSize: "1.25rem",
            fontWeight: "bold",
          }}
        >
          Rejection Remarks
        </DialogTitle>
        <DialogContent sx={{ padding: "24px" }}>
          <Box sx={{ marginBottom: "16px" }}>
            <Typography
              variant="body1"
              sx={{
                marginBottom: "8px",
                color: "#333",
                fontWeight: "500",
              }}
            >
              Please provide the reason for rejection:
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "#666",
                fontStyle: "italic",
              }}
            >
              Remarks must be between 10 and 255 characters.
            </Typography>
          </Box>
          <TextField
            autoFocus
            label="Remarks"
            type="text"
            fullWidth
            multiline
            rows={4}
            value={remarks}
            onChange={(e) => handleRemarksChange(e.target.value)}
            placeholder="Enter detailed reason for rejection (minimum 10 characters, maximum 255 characters)..."
            variant="outlined"
            error={!!remarksError}
            helperText={
              remarksError ||
              `${remarks.trim().length}/255 characters` +
                (remarks.trim().length > 0
                  ? ` (${
                      remarks.trim().length < 10
                        ? `${10 - remarks.trim().length} more required`
                        : "valid length"
                    })`
                  : "")
            }
            sx={{
              "& .MuiOutlinedInput-root": {
                "&:hover fieldset": {
                  borderColor: "#137e81",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#137e81",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#137e81",
              },
              "& .MuiFormHelperText-root": {
                color: remarksError ? "#d32f2f" : "#666",
              },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px", gap: "8px" }}>
          <Button
            onClick={handleCancelRemarks}
            color="secondary"
            variant="outlined"
            sx={{
              borderColor: "#6c757d",
              color: "#6c757d",
              "&:hover": {
                borderColor: "#545b62",
                backgroundColor: "rgba(108, 117, 125, 0.04)",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitRemarks}
            color="primary"
            variant="contained"
            disabled={
              !remarks.trim() ||
              remarks.trim().length < 10 ||
              remarks.trim().length > 255
            }
            sx={{
              backgroundColor: "#137e81",
              "&:hover": {
                backgroundColor: "#0f6c6f",
              },
              "&:disabled": {
                backgroundColor: "#cccccc",
                color: "#666666",
              },
            }}
          >
            Submit Rejection
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SchoolAssessment;
